import { createFileRoute } from "@tanstack/react-router";
import { AppointmentsPage } from "@/components/appointments/appointments-page.tsx";

export const Route = createFileRoute("/_app/")({
  component: AppointmentsPage,
});
